import React, {Component, PureComponent} from 'react';
import './ChildBoxCollapsible.css';

class ChildBoxCollapsible extends PureComponent {
  state = {
    isActive: false,
  };

  reset() {
    const isActive = false;
    this.setState({isActive});
  };

  componentWillUnmount() {
    this.reset();
  }

  componentWillReceiveProps(props) {
    const {isActive} = props;
    this.setState({isActive});
  }

  render() {
    const {isActive} = this.state;
    const {content, title, subTitle, index, handleActive} = this.props;
    const imageActive = '/wp-content/uploads/2018/09/arrow.png';
    const imageDisable = '/wp-content/uploads/2018/09/close.png';
    /*const imageActive = '/assets/arrow.png';
    const imageDisable = '/assets/close.png';*/

    return (
      <div id='Child-box-collapsible' className={(isActive) ? 'animated slideInDown active' : 'animated slideInDown'}>
        <div className='child-header'>
          <div className='child-header-title'>
            <span className='child-title'> {title} </span>
            <span className='child-subtitle'> {subTitle} </span>
          </div>
          <div className='child-header-button'>
            <img alt='button' src={isActive ? imageDisable : imageActive} onClick={() => handleActive(index)}/>
          </div>
        </div>
        <div className='child-content'>
          <div dangerouslySetInnerHTML={{__html: content}}/>
        </div>
      </div>
    )
  }
}

export default ChildBoxCollapsible;



// WEBPACK FOOTER //
// ./src/components/CollapseMaster/ChildBoxCollapsible/ChildBoxCollapsible.js